import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { getAssetUrl as e } from "../assets.js";
import { fetchMessageBundle as r } from "../intl/messages.js";

function a(_x) {
  return _a.apply(this, arguments);
}

function _a() {
  _a = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
    var a, s;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (e) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            a = e.indexOf("-vector") > -1 ? e.slice(0, e.indexOf("-vector")) : e;
            _context.next = 5;
            return r("esri/t9n/basemaps");

          case 5:
            s = _context.sent;
            return _context.abrupt("return", s[e] || s[a]);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _a.apply(this, arguments);
}

var s = {
  streets: {
    id: "streets",
    classic: !0,
    deprecated: !0,

    get thumbnailUrl() {
      return e("esri/images/basemap/streets.jpg");
    },

    baseMapLayers: [{
      id: "streets-base-layer",
      url: "//services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer",
      layerType: "ArcGISTiledMapServiceLayer",
      title: "World Street Map",
      showLegend: !1,
      visibility: !0,
      opacity: 1
    }]
  },
  satellite: {
    id: "satellite",
    classic: !0,

    get thumbnailUrl() {
      return e("esri/images/basemap/satellite.jpg");
    },

    baseMapLayers: [{
      id: "satellite-base-layer",
      url: "//services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer",
      layerType: "ArcGISTiledMapServiceLayer",
      title: "World Imagery",
      showLegend: !1,
      visibility: !0,
      opacity: 1
    }]
  },
  hybrid: {
    id: "hybrid",
    classic: !0,

    get thumbnailUrl() {
      return e("esri/images/basemap/hybrid.jpg");
    },

    baseMapLayers: [{
      id: "hybrid-base-layer",
      url: "//services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer",
      layerType: "ArcGISTiledMapServiceLayer",
      title: "World Imagery",
      showLegend: !1,
      visibility: !0,
      opacity: 1
    }, {
      id: "hybrid-reference-layer",
      url: "//services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer",
      layerType: "ArcGISTiledMapServiceLayer",
      title: "World Boundaries and Places",
      isReference: !0,
      showLegend: !1,
      visibility: !0,
      opacity: 1
    }]
  },
  terrain: {
    id: "terrain",
    classic: !0,

    get thumbnailUrl() {
      return e("esri/images/basemap/terrain.jpg");
    },

    baseMapLayers: [{
      id: "terrain-base-layer",
      url: "//services.arcgisonline.com/ArcGIS/rest/services/World_Terrain_Base/MapServer",
      layerType: "ArcGISTiledMapServiceLayer",
      title: "World Terrain Base",
      showLegend: !1,
      visibility: !0,
      opacity: 1
    }, {
      id: "terrain-reference-layer",
      url: "//services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Reference_Overlay/MapServer",
      layerType: "ArcGISTiledMapServiceLayer",
      title: "World Reference Overlay",
      isReference: !0,
      showLegend: !1,
      visibility: !0,
      opacity: 1
    }]
  },
  topo: {
    id: "topo",
    classic: !0,
    deprecated: !0,

    get thumbnailUrl() {
      return e("esri/images/basemap/topo.jpg");
    },

    baseMapLayers: [{
      id: "topo-base-layer",
      url: "//services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer",
      layerType: "ArcGISTiledMapServiceLayer",
      title: "World Topo Map",
      showLegend: !1,
      visibility: !0,
      opacity: 1
    }]
  },
  gray: {
    id: "gray",
    classic: !0,
    deprecated: !0,

    get thumbnailUrl() {
      return e("esri/images/basemap/gray.jpg");
    },

    baseMapLayers: [{
      id: "gray-base-layer",
      url: "//services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer",
      layerType: "ArcGISTiledMapServiceLayer",
      title: "World Light Gray Base",
      showLegend: !1,
      visibility: !0,
      opacity: 1
    }, {
      id: "gray-reference-layer",
      url: "//services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer",
      layerType: "ArcGISTiledMapServiceLayer",
      title: "World Light Gray Reference",
      isReference: !0,
      showLegend: !1,
      visibility: !0,
      opacity: 1
    }]
  },
  "dark-gray": {
    id: "dark-gray",
    classic: !0,
    deprecated: !0,

    get thumbnailUrl() {
      return e("esri/images/basemap/dark-gray.jpg");
    },

    baseMapLayers: [{
      id: "dark-gray-base-layer",
      url: "//services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer",
      layerType: "ArcGISTiledMapServiceLayer",
      title: "World Dark Gray Base",
      showLegend: !1,
      visibility: !0,
      opacity: 1
    }, {
      id: "dark-gray-reference-layer",
      url: "//services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Reference/MapServer",
      layerType: "ArcGISTiledMapServiceLayer",
      title: "World Dark Gray Reference",
      isReference: !0,
      showLegend: !1,
      visibility: !0,
      opacity: 1
    }]
  },
  oceans: {
    id: "oceans",
    classic: !0,

    get thumbnailUrl() {
      return e("esri/images/basemap/oceans.jpg");
    },

    baseMapLayers: [{
      id: "oceans-base-layer",
      url: "//services.arcgisonline.com/arcgis/rest/services/Ocean/World_Ocean_Base/MapServer",
      layerType: "ArcGISTiledMapServiceLayer",
      title: "World Ocean Base",
      showLegend: !1,
      visibility: !0,
      opacity: 1
    }, {
      id: "oceans-reference-layer",
      url: "//services.arcgisonline.com/arcgis/rest/services/Ocean/World_Ocean_Reference/MapServer",
      layerType: "ArcGISTiledMapServiceLayer",
      title: "World Ocean Reference",
      isReference: !0,
      showLegend: !1,
      visibility: !0,
      opacity: 1
    }]
  },
  "national-geographic": {
    id: "national-geographic",
    classic: !0,
    deprecated: !0,

    get thumbnailUrl() {
      return e("esri/images/basemap/national-geographic.jpg");
    },

    baseMapLayers: [{
      id: "national-geographic-base-layer",
      url: "//services.arcgisonline.com/ArcGIS/rest/services/NatGeo_World_Map/MapServer",
      title: "NatGeo World Map",
      showLegend: !1,
      layerType: "ArcGISTiledMapServiceLayer",
      visibility: !0,
      opacity: 1
    }]
  },
  osm: {
    id: "osm",
    classic: !0,

    get thumbnailUrl() {
      return e("esri/images/basemap/osm.jpg");
    },

    baseMapLayers: [{
      id: "osm-base-layer",
      layerType: "OpenStreetMap",
      title: "Open Street Map",
      showLegend: !1,
      visibility: !0,
      opacity: 1
    }]
  },
  "dark-gray-vector": {
    id: "dark-gray-vector",
    classic: !0,

    get thumbnailUrl() {
      return e("esri/images/basemap/dark-gray-vector.jpg");
    },

    baseMapLayers: [{
      id: "dark-gray-base-layer",
      styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/5e9b3685f4c24d8781073dd928ebda50/resources/styles/root.json",
      layerType: "VectorTileLayer",
      title: "Dark Gray Base",
      visibility: !0,
      opacity: 1
    }, {
      id: "dark-gray-reference-layer",
      styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/747cb7a5329c478cbe6981076cc879c5/resources/styles/root.json",
      layerType: "VectorTileLayer",
      title: "Dark Gray Reference",
      isReference: !0,
      visibility: !0,
      opacity: 1
    }]
  },
  "gray-vector": {
    id: "gray-vector",
    classic: !0,

    get thumbnailUrl() {
      return e("esri/images/basemap/gray-vector.jpg");
    },

    baseMapLayers: [{
      id: "gray-base-layer",
      styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/291da5eab3a0412593b66d384379f89f/resources/styles/root.json",
      layerType: "VectorTileLayer",
      title: "Light Gray Base",
      visibility: !0,
      opacity: 1
    }, {
      id: "gray-reference-layer",
      styleUrl: "https://cdn.arcgis.com/sharing/rest/content/items/1768e8369a214dfab4e2167d5c5f2454/resources/styles/root.json",
      layerType: "VectorTileLayer",
      title: "Light Gray Reference",
      isReference: !0,
      visibility: !0,
      opacity: 1
    }]
  },
  "streets-vector": {
    id: "streets-vector",
    classic: !0,

    get thumbnailUrl() {
      return e("esri/images/basemap/streets-vector.jpg");
    },

    baseMapLayers: [{
      id: "streets-vector-base-layer",
      styleUrl: "//cdn.arcgis.com/sharing/rest/content/items/de26a3cf4cc9451298ea173c4b324736/resources/styles/root.json",
      layerType: "VectorTileLayer",
      title: "World Streets",
      visibility: !0,
      opacity: 1
    }]
  },
  "topo-vector": {
    id: "topo-vector",
    classic: !0,

    get thumbnailUrl() {
      return e("esri/images/basemap/topo-vector.jpg");
    },

    baseMapLayers: [{
      id: "world-hillshade-layer",
      url: "//services.arcgisonline.com/arcgis/rest/services/Elevation/World_Hillshade/MapServer",
      layerType: "ArcGISTiledMapServiceLayer",
      title: "World Hillshade",
      showLegend: !1,
      visibility: !0,
      opacity: 1
    }, {
      id: "topo-vector-base-layer",
      styleUrl: "//cdn.arcgis.com/sharing/rest/content/items/7dc6cea0b1764a1f9af2e679f642f0f5/resources/styles/root.json",
      layerType: "VectorTileLayer",
      title: "World Topo",
      visibility: !0,
      opacity: 1
    }]
  },
  "streets-night-vector": {
    id: "streets-night-vector",
    classic: !0,

    get thumbnailUrl() {
      return e("esri/images/basemap/streets-night.jpg");
    },

    baseMapLayers: [{
      id: "streets-night-vector-base-layer",
      styleUrl: "//cdn.arcgis.com/sharing/rest/content/items/86f556a2d1fd468181855a35e344567f/resources/styles/root.json",
      layerType: "VectorTileLayer",
      title: "World Streets Night",
      visibility: !0,
      opacity: 1
    }]
  },
  "streets-relief-vector": {
    id: "streets-relief-vector",
    classic: !0,

    get thumbnailUrl() {
      return e("esri/images/basemap/streets-relief.jpg");
    },

    baseMapLayers: [{
      id: "world-hillshade-layer",
      url: "//services.arcgisonline.com/arcgis/rest/services/Elevation/World_Hillshade/MapServer",
      layerType: "ArcGISTiledMapServiceLayer",
      title: "World Hillshade",
      showLegend: !1,
      visibility: !0,
      opacity: 1
    }, {
      id: "streets-relief-vector-base-layer",
      styleUrl: "//www.arcgis.com/sharing/rest/content/items/b266e6d17fc345b498345613930fbd76/resources/styles/root.json",
      title: "World Streets Relief",
      layerType: "VectorTileLayer",
      visibility: !0,
      opacity: 1
    }]
  },
  "streets-navigation-vector": {
    id: "streets-navigation-vector",
    classic: !0,

    get thumbnailUrl() {
      return e("esri/images/basemap/streets-navigation.jpg");
    },

    baseMapLayers: [{
      id: "streets-navigation-vector-base-layer",
      styleUrl: "//cdn.arcgis.com/sharing/rest/content/items/63c47b7177f946b49902c24129b87252/resources/styles/root.json",
      layerType: "VectorTileLayer",
      title: "World Streets Navigation",
      visibility: !0,
      opacity: 1
    }]
  },
  "arcgis-imagery": {
    get thumbnailUrl() {
      return e("esri/images/basemap/hybrid.jpg");
    },

    title: "Imagery Hybrid",
    baseMapLayers: [{
      layerType: "ArcGISTiledMapServiceLayer",
      showLegend: !1,
      title: "World Imagery",
      url: "https://ibasemaps-api.arcgis.com/arcgis/rest/services/World_Imagery/MapServer"
    }, {
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/ArcGIS:Imagery:Labels",
      title: "Hybrid Reference Layer",
      isReference: !0
    }]
  },
  "arcgis-imagery-standard": {
    get thumbnailUrl() {
      return e("esri/images/basemap/satellite.jpg");
    },

    title: "Imagery",
    baseMapLayers: [{
      layerType: "ArcGISTiledMapServiceLayer",
      showLegend: !1,
      title: "World Imagery",
      url: "https://ibasemaps-api.arcgis.com/arcgis/rest/services/World_Imagery/MapServer"
    }]
  },
  "arcgis-imagery-labels": {
    title: "Hybrid [Reference]",
    baseMapLayers: [{
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/ArcGIS:Imagery:Labels",
      title: "Hybrid Reference Layer",
      isReference: !0
    }]
  },
  "arcgis-light-gray": {
    get thumbnailUrl() {
      return e("esri/images/basemap/gray-vector.jpg");
    },

    title: "Light Gray Canvas",
    baseMapLayers: [{
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/ArcGIS:LightGray:Base",
      title: "Light Gray Canvas Base"
    }, {
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/ArcGIS:LightGray:Labels",
      title: "Light Gray Canvas Labels",
      isReference: !0
    }]
  },
  "arcgis-dark-gray": {
    get thumbnailUrl() {
      return e("esri/images/basemap/dark-gray.jpg");
    },

    title: "Dark Gray Canvas",
    baseMapLayers: [{
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/ArcGIS:DarkGray:Base",
      title: "Dark Gray Canvas Base"
    }, {
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/ArcGIS:DarkGray:Labels",
      title: "Dark Gray Canvas Labels",
      isReference: !0
    }]
  },
  "arcgis-navigation": {
    get thumbnailUrl() {
      return e("esri/images/basemap/streets-navigation.jpg");
    },

    title: "Navigation",
    baseMapLayers: [{
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/ArcGIS:Navigation",
      title: "World Navigation Map"
    }]
  },
  "arcgis-navigation-night": {
    title: "Navigation (Dark Mode)",
    baseMapLayers: [{
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/ArcGIS:NavigationNight",
      title: "World Navigation Map (Dark Mode)"
    }]
  },
  "arcgis-streets": {
    get thumbnailUrl() {
      return e("esri/images/basemap/streets-vector.jpg");
    },

    title: "Streets",
    baseMapLayers: [{
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/ArcGIS:Streets",
      title: "World Street Map"
    }]
  },
  "arcgis-streets-night": {
    get thumbnailUrl() {
      return e("esri/images/basemap/streets-night.jpg");
    },

    title: "Streets (Night)",
    baseMapLayers: [{
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/ArcGIS:StreetsNight",
      title: "World Street Map (Night)"
    }]
  },
  "arcgis-streets-relief": {
    get thumbnailUrl() {
      return e("esri/images/basemap/streets-relief.jpg");
    },

    title: "Streets (with Relief)",
    baseMapLayers: [{
      layerType: "ArcGISTiledMapServiceLayer",
      showLegend: !1,
      title: "World Hillshade",
      url: "https://ibasemaps-api.arcgis.com/arcgis/rest/services/Elevation/World_Hillshade/MapServer"
    }, {
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/ArcGIS:StreetsRelief:Base",
      title: "World Street Map (with Relief)"
    }]
  },
  "arcgis-topographic": {
    get thumbnailUrl() {
      return e("esri/images/basemap/topo.jpg");
    },

    title: "Topographic",
    baseMapLayers: [{
      layerType: "ArcGISTiledMapServiceLayer",
      showLegend: !1,
      title: "World Hillshade",
      url: "https://ibasemaps-api.arcgis.com/arcgis/rest/services/Elevation/World_Hillshade/MapServer"
    }, {
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/ArcGIS:Topographic:Base",
      title: "World Topographic Map"
    }]
  },
  "arcgis-oceans": {
    get thumbnailUrl() {
      return e("esri/images/basemap/oceans.jpg");
    },

    title: "Oceans",
    baseMapLayers: [{
      layerType: "ArcGISTiledMapServiceLayer",
      showLegend: !1,
      title: "World Ocean Base",
      url: "https://ibasemaps-api.arcgis.com/arcgis/rest/services/Ocean/World_Ocean_Base/MapServer"
    }, {
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/ArcGIS:Oceans:Labels",
      title: "World Ocean Reference",
      isReference: !0
    }]
  },
  "osm-standard": {
    title: "OpenStreetMap",
    baseMapLayers: [{
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/OSM:Standard",
      title: "OpenStreetMap"
    }]
  },
  "osm-standard-relief": {
    title: "OpenStreetMap (with relief)",
    baseMapLayers: [{
      layerType: "ArcGISTiledMapServiceLayer",
      showLegend: !1,
      title: "World Hillshade",
      url: "https://ibasemaps-api.arcgis.com/arcgis/rest/services/Elevation/World_Hillshade/MapServer"
    }, {
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/OSM:StandardRelief:Base",
      layerType: "VectorTileLayer",
      title: "OpenStreetMap Relief Base"
    }]
  },
  "osm-streets": {
    title: "OpenStreetMap (Streets)",
    baseMapLayers: [{
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/OSM:Streets",
      title: "OpenStreetMap (Streets)"
    }]
  },
  "osm-streets-relief": {
    title: "OpenStreetMap (Streets with relief)",
    baseMapLayers: [{
      layerType: "ArcGISTiledMapServiceLayer",
      showLegend: !1,
      title: "World Hillshade",
      url: "https://ibasemaps-api.arcgis.com/arcgis/rest/services/Elevation/World_Hillshade/MapServer"
    }, {
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/OSM:StreetsRelief:Base",
      layerType: "VectorTileLayer",
      title: "OpenStreetMap Relief Base"
    }]
  },
  "osm-light-gray": {
    title: "OpenStreetMap (Light Gray Canvas)",
    baseMapLayers: [{
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/OSM:LightGray:Base",
      title: "OSM (Light Gray Base)"
    }, {
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/OSM:LightGray:Labels",
      title: "OSM (Light Gray Reference)",
      isReference: !0
    }]
  },
  "osm-dark-gray": {
    title: "OpenStreetMap (Dark Gray Canvas)",
    baseMapLayers: [{
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/OSM:DarkGray:Base",
      title: "OSM (Dark Gray Base)"
    }, {
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/OSM:DarkGray:Labels",
      title: "OSM (Dark Gray Reference)",
      isReference: !0
    }]
  },
  "arcgis-terrain": {
    title: "Terrain with Labels",
    baseMapLayers: [{
      layerType: "ArcGISTiledMapServiceLayer",
      showLegend: !1,
      title: "World Hillshade",
      url: "https://ibasemaps-api.arcgis.com/arcgis/rest/services/Elevation/World_Hillshade/MapServer"
    }, {
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/ArcGIS:Terrain:Base",
      title: "World Terrain Base"
    }, {
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/ArcGIS:Terrain:Detail",
      title: "World Terrain Reference",
      isReference: !0
    }]
  },
  "arcgis-community": {
    title: "Community",
    baseMapLayers: [{
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/ArcGIS:Community",
      title: "Community"
    }]
  },
  "arcgis-charted-territory": {
    title: "Charted Territory",
    baseMapLayers: [{
      layerType: "ArcGISTiledMapServiceLayer",
      showLegend: !1,
      title: "World Hillshade",
      url: "https://ibasemaps-api.arcgis.com/arcgis/rest/services/Elevation/World_Hillshade/MapServer"
    }, {
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/ArcGIS:ChartedTerritory:Base",
      title: "Charted Territory"
    }]
  },
  "arcgis-colored-pencil": {
    title: "Colored Pencil",
    baseMapLayers: [{
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/ArcGIS:ColoredPencil",
      title: "Colored Pencil"
    }]
  },
  "arcgis-nova": {
    title: "Nova",
    baseMapLayers: [{
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/ArcGIS:Nova",
      title: "Nova"
    }]
  },
  "arcgis-modern-antique": {
    title: "Modern Antique",
    baseMapLayers: [{
      layerType: "ArcGISTiledMapServiceLayer",
      showLegend: !1,
      title: "World Hillshade",
      url: "https://ibasemaps-api.arcgis.com/arcgis/rest/services/Elevation/World_Hillshade/MapServer"
    }, {
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/ArcGIS:ModernAntique:Base",
      title: "Modern Antique"
    }]
  },
  "arcgis-midcentury": {
    title: "Mid-Century",
    baseMapLayers: [{
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/ArcGIS:Midcentury",
      title: "Mid-Century"
    }]
  },
  "arcgis-newspaper": {
    title: "Newspaper",
    baseMapLayers: [{
      layerType: "VectorTileLayer",
      styleUrl: "https://basemaps-api.arcgis.com/arcgis/rest/services/styles/ArcGIS:Newspaper",
      title: "Newspaper"
    }]
  },
  "arcgis-hillshade-light": {
    title: "Hillshade",
    baseMapLayers: [{
      layerType: "ArcGISTiledMapServiceLayer",
      showLegend: !1,
      title: "World Hillshade",
      url: "https://ibasemaps-api.arcgis.com/arcgis/rest/services/Elevation/World_Hillshade/MapServer"
    }]
  },
  "arcgis-hillshade-dark": {
    title: "Hillshade (Dark)",
    baseMapLayers: [{
      layerType: "ArcGISTiledMapServiceLayer",
      showLegend: !1,
      title: "World Hillshade (Dark)",
      url: "https://ibasemaps-api.arcgis.com/arcgis/rest/services/Elevation/World_Hillshade_Dark/MapServer"
    }]
  }
};
export { s as esriBasemapDefinitions, a as getBasemapTitle };